<!-- start Header -->
<!-- <header id="header-waypoint-sticky" class="header-main header-mobile-menu with-absolute-navbar"> -->

<div class="trest">
    <ng-template #signincontainer></ng-template>
    <ng-template #signupcontainer></ng-template>
</div>

<!-- </header> -->
<!-- end Header -->
<!-- =========================================================================================== -->
<header class="ytb-v2-header-area">
    <div class="container">
        <div class="ytb-v2-header-content">
            <div class="row ">
                <div class="col-md-5">
                    <div class="ytb-v2-header-left">
                        <div class="ytb-v2-logo-area">
                            <a (click)="navigateToHome()">
                                <img src="assets/images/footer-images/logo.png" alt="Logo">
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-md-7">
                    <div class="ytb-v2-header-right">

                        <div class="ytb-v2-header-left ytb-v2-lan-menu">
                            <ul class="ytb-v2-lan-menu-opn">
                                <li class="ytb-v2-menu-item">
                                    <a  id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false"> <span #button> </span> <i
                                        class="fa fa-angle-down"></i>  </a>
                                    <div class="ytb-v2-submenu ytb-v2-lan-cur-sec dropdown-menu dropdown-content"
                                        aria-labelledby="navbarDropdownMenuLink">
                                        <div class="ytb-v2-lan-select">
                                            <b> {{ currenctLanguage() }}</b>
                                            <ul>
                                                <li *ngFor="let lang of languagesData()"><a
                                                        (click)="onLangClick(lang.languageCode, lang.language)">{{
                                                        lang.language }}</a></li>

                                            </ul>
                                        </div>
                                        <div class="ytb-v2-cur-select">
                                            <b>Currency</b>
                                            <ul>
                                                <li *ngFor="let group of popularCurrencysDropdown()">
                                                    <a class="dropdown-item" (click)="
                                getCurrencyName(
                                  group.value,
                                  group.label
                                )
                              ">
                                                        {{group.label}}</a>
                                                </li>

                                            </ul>
                                        </div>
                                    </div>
                                </li>
                                <li class="ytb-v2-menu-item">
                                    <a  id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false" (click)="openLinkOnTab('/help')">Help</a>
                                </li>

                                <li class="ytb-v2-menu-item" *ngIf="enableMyAccount()">
                                    <a  id="navbarDropdownMenuLinkMyAccount" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false">
                                        My Account<i class="fa fa-angle-down"></i></a>
                                    <div class="ytb-v2-submenu dropdown-menu dropdown-content"
                                        aria-labelledby="navbarDropdownMenuLinkMyAccount">

                                        <ul>
                                            <li> <a (click)="openLinkOnTab('my-account')" alt="">View Profile</a></li>
                                            <li><a (click)="openLinkOnTab('change-password')" alt="">Change Password</a>
                                            </li>
                                            <li> <a (click)="logout()" alt="">Logout</a></li>

                                        </ul>
                                    </div>

                                </li>


                            </ul>
                        </div>
                        <a href="#" class="ytb-v2-call-btn">
                            <img src="./assets/images/footer-images/COA-agent-pic.png" alt="">
                            <span *ngIf="mobileArr() && mobileArr().length > 0">
                                <p> +{{ mobileArr()[0].countryPhoneCode }}
                                    {{ mobileArr()[0].contactValue }}</p>
                                Customer Support
                            </span>
                        </a>
                        <ng-container *ngIf="!enableMyAccount()">
                            <button class="ytb-v2-signup-btn" (click)="loadSignInComponent()">
                                <img src="/assets/images/footer-images/icon/user.png" alt="">
                                <b>Sign In / Join</b>
                            </button>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>